import React from 'react';

import { Accordion, Textarea } from '@mantine/core';

interface WorkoutNotesAccordionProps {
  value: string;
  onChange: (value: string) => void;
  onBlur: (value: string) => void;
}

const WorkoutNotesAccordion = ({ value, onChange, onBlur }: WorkoutNotesAccordionProps): JSX.Element => (
  <Accordion variant='contained'>
    <Accordion.Item value='notes'>
      <Accordion.Control>Overall Workout Notes (optional)</Accordion.Control>
      <Accordion.Panel>
        <Textarea
          value={value}
          onChange={e => onChange(e.currentTarget.value)}
          onBlur={e => onBlur(e.currentTarget.value)}
          placeholder='How was your overall workout? Any feedback for your coach?'
          minRows={3}
          autosize
        />
      </Accordion.Panel>
    </Accordion.Item>
  </Accordion>
);

export default WorkoutNotesAccordion;
